import LabelIcon
    from "../../../../../../screens/sharing/components/list-of-groups/components/label/components/label-icon";
import {sharedWordRemove} from "../../../../../../utils";
import SharingPreview from "../../../../../sharing-preview";
import Loader from "../../../../../sprite/components/loader";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {findLabels, selectOneLabelFromPopup as setSelectOneLabelFromPopup} from "../../../../../../../actions/contactsGroupItemActions";
import './index.css';

function SelectLabelToAdd () {

    const { t } = useTranslation();

    const [scrollTop, setScrollTop] = useState(0);
    const [viewportHeight, setViewportHeight] = useState(0);
    const [filteredLabels, setFilteredLabels] = useState(null);

    const labels = useSelector( state => state.contactsGroupItemReducer.findLabels);
    const selectOneLabelFromPopup = useSelector( state => state.contactsGroupItemReducer.selectOneLabelFromPopup);

    const dispatch = useDispatch();

    const rowHeight = 32;
    const amountRowsBuffered = 2;

    useEffect(() => {
        if(document.querySelector('.gmail-select-one-label-popup')) {
            setViewportHeight(document.querySelector('.gmail-select-one-label-popup .modal-body').clientHeight);
        } else {
            setViewportHeight(document.querySelector('.select-label-to-add').clientHeight);
        }
    }, []);

    /*if(labels){
        setFilteredLabels(labels.contactsGroups.filter(item => item.permission !== 'READ_ONLY').map((item, index) => {
            return (
                {
                    ...item,
                    position: index + 1
                }
            )
        }))
    }*/

    let totalRows = filteredLabels ? filteredLabels.length : 0;

    let indexStart = Math.max(
        Math.floor(scrollTop / rowHeight) - amountRowsBuffered,
        0
    );

    let indexEnd = Math.min(
        Math.ceil((scrollTop + viewportHeight) / rowHeight - 1) +
        amountRowsBuffered,
        totalRows - 1
    );

    const selectLabel = (e) => {
        dispatch(setSelectOneLabelFromPopup({
            id: e.currentTarget.dataset.id,
            name: e.currentTarget.dataset.name,
            status: e.currentTarget.dataset.status,
            permission: e.currentTarget.dataset.permission,
            ownerId: e.currentTarget.dataset.ownerId
        }));
    };

    const update = (e) => {
        setScrollTop(e.target.scrollTop);
    };

    useEffect(() => {
        if(labels){
            setFilteredLabels(labels.contactsGroups.filter(item => item.permission === 'OWNER' || item.permission === 'CAN_SHARE').map((item, index) => {
                return (
                    {
                        ...item,
                        position: index + 1
                    }
                )
            }))
        } else {
            dispatch(findLabels(50));
        }
    },[dispatch, labels]);

    useEffect(() => {
        if(filteredLabels){
	        if(filteredLabels.length > 0) {
		        dispatch(setSelectOneLabelFromPopup({
			        id: filteredLabels[0].id,
			        name: filteredLabels[0].name,
			        status: filteredLabels[0].status,
			        permission: filteredLabels[0].permission,
			        ownerId: filteredLabels[0].ownerId
		        }));
	        }
        }
    },[dispatch, filteredLabels]);

    return (
        <div className="select-label-to-add" onScroll={ update }>
            {
                filteredLabels !== null
                ?
                    filteredLabels.length > 0
                    ?
                        <div style={{
                            height: rowHeight * totalRows,
                            overflowX: 'hidden'
                        }}>
                            {
                                filteredLabels.slice(indexStart, indexEnd + 1).map(filteredLabel => {

                                    /*
                                    * If that's not from a research the selected label is excluded
                                    * */

                                    return (
                                        <div
                                            key={filteredLabel.id}
                                            className="select-one-label-popup__label custom-control custom-radio"
                                            style={{
                                                height: rowHeight,
                                                top: filteredLabel.position * rowHeight - rowHeight
                                            }}
                                        >
                                            <input
                                                type="radio"
                                                data-id={filteredLabel.id}
                                                data-name={filteredLabel.name}
                                                data-status={filteredLabel.status}
                                                data-owner-id={filteredLabel.ownerId}
                                                checked={selectOneLabelFromPopup?.id === filteredLabel?.id}
                                                data-permission={filteredLabel.permission}
                                                onChange={selectLabel}
                                                className="custom-control-input"
                                                id={`label-checkbox-${filteredLabel.id}`}
                                                name={"label"}
                                            />
                                            <label className="custom-control-label flex-shrink-0"
                                                   htmlFor={`label-checkbox-${filteredLabel.id}`}>
                                                <LabelIcon type={filteredLabel.type}/>
                                                {sharedWordRemove(filteredLabel.name)} ({filteredLabel.nbOfContact})
                                            </label>
                                            <SharingPreview
                                                permission={filteredLabel.permission}
                                                labelId={filteredLabel.id}
                                                collaborators={filteredLabel.sharingPreview}
                                                sharingNumber={filteredLabel.sharingNumber}
                                                status={filteredLabel.status}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    :
                        <p>{t("textNoContactListsFound")}</p>
                :
                    <Loader/>
            }

        </div>
    )
}

export default SelectLabelToAdd;
